import FormJaivana from 'dashboard_jaivana_v1';

/**
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomRecepcionMercanciaPintunal extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                   = this.initForm.bind(this);
        this.successTablaItemFichas     = this.successTablaItemFichas.bind(this);
        this.setButtonDelete            = this.setButtonDelete.bind(this);
        this.terminarItem               = this.terminarItem.bind(this);
        this.devolverItem               = this.devolverItem.bind(this);
        this.successRecibido            = this.successRecibido.bind(this);
        this.uploadTable                = this.uploadTable.bind(this);
        this.formato                    = this.formato.bind(this);
        this.tamanoDatos                = 0;
        this.succesTraerDatosFicha      = this.succesTraerDatosFicha.bind(this);
        this.verFormula                 = this.verFormula.bind(this);
        this.successVerFormula          = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula      = Object.assign({}, this.gridOptions);
        this.successClose               = this.successClose.bind(this);
    }

    initForm() {
        console.log('CustomRecepcionMercancia, @version: 1.01.0054, @author:Sebastian Noreña Márquez, @updated: Sebastian Rios E.');
     
         let datos = {
            datos:{
                value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }

        // produccion_fichas-iddatos

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesTraerDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_traer_datos_fichas_recepcion_mercancia'; //nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: bodys,
                success: this.succesTraerDatosFicha,
                error: this.error_,
                general: this.generalFormat
            });*/

        let datos2 = {
            datos:{
                value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitemsleidos', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos2,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = 'servicio_traer_items_fichas_recepcion_mercancia'; //nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTablaItemFichas,
                error: this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
       //this.service.send(this.getConstant().searchFormat().format(this.props.data.id_ficha,"listaMercancia",'f9_servicio',this.formId), 'GET', undefined ,this.successTablaItemFichas,this.error_);
        this.getField('btnTerminar').setClick(this.terminarItem);
        this.getField('btnDevolver').setClick(this.devolverItem);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.data;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    succesTraerDatosFicha(data){
        //console.log("entro al succesficha",data);
        let datosFicha = [];
        if(data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            this.getField('listaMercancia').setVisible(true);
            datosFicha.push(data.data[0]);
            //console.log("entro al if",datosFicha);
            this.getField('listaMercancia').setItemsFichas(datosFicha);
        }else{
            this.getField('listaMercancia').setVisible(false);
        }
    }

    formato(props){
        return ("".formatoPrecio(props.data.cantidad));
    }

    successTablaItemFichas(data){
        //console.log("datos de la tabla",data);
        if(data.estado_p === 200){
            let configCell = new Map();
            this.tamanoDatos = data.data.length;
            configCell.set('cantidad',{cellRenderer:this.formato, cellStyle: { textAlign: "right" },field: 'cantidad' });
            configCell.set(0,{cellRenderer:this.setButtonDelete ,field: 'Operación 1' });
            this.gridOptions['rowData'] = data.data;
            this.getField('tablaMercancia').initData(this.gridOptions,configCell);
        }else{
            this.getField('tablaMercancia').toggle(false);
            this.tamanoDatos = 0;
        }
    }
    
    setButtonDelete(props){
        let id = props.data.id;
        let button = document.createElement("input"); 
        button.onclick = ()=>this.deleteEspecification(id);
        button.setAttribute("id",'button_delete_'+id);
        button.setAttribute("class","buttonStyle");//,"width:100%;height:100%;background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type","button");
        button.setAttribute("value","Recibir");
        
        if(props.data.recibido === 1)
            return "";
        return this.createElementJaivana(button);
    }

    deleteEspecification(id){
       //console.log("id del registro de la tabla",id);
        /**let data = {
            accion:'servicio',
            campo:'tablaMercancia',
            id_formulario: this.formId,
            id:id,
        }*/
        let datos = {
            datos:{
                id:id, //value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitemsleidos', operacion: 'recibido', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successRecibido,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_actualizar_items_fichas_recepcion_mercancia'; //ojo!este no recibe parametros nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successRecibido,
                error: this.error_,
                general: this.generalFormat
            });*/
       //this.service.send(this.getConstant().formSave(), 'PUT', data  ,this.successRecibido,this.error_);
    }

    successRecibido(data){
        if(data.estado_p === 200)
            if(this.tamanoDatos > 1)
                this.uploadTable();
            else{
                this.getField('tablaMercancia').toggle(false);
                this.tamanoDatos = 0;
            }
    }

    uploadTable(){ 
        
        let datos2 = {
            datos:{
                value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitemsleidos', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos2,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*let body = {
            value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
        }

        this.generalFormat.nombre_accion = 'servicio_traer_items_fichas_recepcion_mercancia'; //nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTablaItemFichas,
                error: this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
       //this.service.send(this.getConstant().searchFormat().format(this.props.data.id_ficha,"listaMercancia",'f9_servicio',this.formId), 'GET', undefined ,this.successTablaItemFichas,this.error_);
    }

    terminarItem(){
        if(this.tamanoDatos === 0){
            /**let data = {
                accion:'servicio',
                campo:'btnTerminar',
                id_formulario: this.formId,
                produccion_fichas_id: this.props.data.id_ficha,
                proceso_id: this.props.data.proceso_id,
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id
            }*/
           this.mostrarMensajeGenerando();
            this.getField('btnTerminar').setDisabled(true);
            let datos = {
                datos:{
                    produccion_fichas_id: this.props.data.id_ficha,
                    proceso_id: this.props.data.proceso_id,
                    actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                    actividad_id: this.props.data.actividad_id, //value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-fichasitemsleidos', operacion: 'terminar', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successClose,
                error: this.error_,
                general: this.generalFormatPmv
            });
    
            /*this.generalFormat.nombre_accion = 'servicio_terminar_recepcion_mercancia'; //ojo!este no recibe parametros nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send( 
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: body,
                    success: this.successCloseEstage,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }else
            this.alertGeneral.toggle(true,'Aún hay ítems sin recibir',"error");
    }

    successClose(data){
        this.successCloseEstage(data);
        this.getField('confirmModalCustom').toggle(false);
        this.getField('btnDevolver').setDisabled(false);
        this.getField('btnTerminar').setDisabled(false);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    devolverItem(){
        this.mostrarMensajeGenerando();
        let datos = {
            datos:{
                produccion_fichas_id: this.props.data.id_ficha,
                proceso_id: this.props.data.proceso_id,
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id, //value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }
        this.getField('btnDevolver').setDisabled(true);

        
        this.generalFormatPmv = { tipo_servicio: 'prod-alistamiento', operacion: 'devolver', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successClose,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_devolver_alistamiento_recepcion_mercancia'; //ojo!este no recibe parametros nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormat
            });*/
       //this.service.send(this.getConstant().formSave(), 'PUT', data  ,this.successCloseEstage,this.error_);
    }

}
FormJaivana.addController("prod-fichasitemsleidos",CustomRecepcionMercanciaPintunal);

export default CustomRecepcionMercanciaPintunal;